import styled from 'styled-components';
import React from 'react';

export const CardContainer = styled.div`
    background: white;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    margin-bottom: var(--space-lg);

    ${({color}) => {
        if (color)
            return `
            display: inline-block;
            background: #f2f7fe;
            border: 1px solid #f2f7fe;
            * {
                color: var(--${color});
                font-size: 14px;
            }
        `;
        else return '';
    }}

    ${({size}) => {
        if (size === 'small')
            return `
            ${CardBody} ,
            ${CardHead} {
                padding: var(--space-sm);
            }
        `;
        else return '';
    }}
`;

export const CardBody = styled.div`
    padding: var(--space-lg);
`;

export const CardHead = styled.div`
    background: #edeef0;
    padding: var(--space-sm) var(--space-lg);
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #f2f7fe;
    font-size: 14px;
`;

export const Card = ({children, size, header, color}) => (
    <CardContainer size={size} color={color}>
        {header && <CardHead>{header}</CardHead>}
        <CardBody>{children}</CardBody>
    </CardContainer>
);
